import markScreenSelected from '../../gateways/browser/mark_screen_selected';
import getInvestigations from '../../data_management/getQuestionnaireInstanceBatches';

const QuestionnairesController = function ($scope, investigationInteractor, initialDataInteractor) {
  const $ctrl = this;

  markScreenSelected("questionnaires");

  initialDataInteractor.ensureInitializedSession().then(() => {
      $ctrl.investigations = getInvestigations(initialDataInteractor);
      $scope.$digest();
    }
  );

  $ctrl.updateInvestigations = function () {
    $scope.$digest();
  }
};

export default {
  name: 'QuestionnairesController',
  fn: QuestionnairesController
};